module.exports = __webpack_public_path__ + "img/azay-chauffage.0fc4458e.png";